/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isObject from 'lodash/isObject';

// TODO Přejmenovat na PromiseQueueFactory nebo rovnou nahradit za knihovnu?
// - https://github.com/sindresorhus/p-queue
/**
 * Továrna na fronty asynchronních akcí.
 */
class QueueFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<Queue>} Queue Konstruktor fronty asynchronních akcí.
   * @returns {QueueFactory} Nová instance.
   */
  constructor(Queue) {
    if (!isObject(Queue)) {
      throw new TypeError(`Invalid queue constructor ${Queue}.`);
    }
    this.Queue = Queue;
  }

  /**
   * Vytvoří novou frontu asynchronních akcí.
   * @returns {Queue} Vytvořená fronta.
   */
  create() {
    return new this.Queue();
  }
}

export default QueueFactory;
